<template>
    <div class="list__item item_view_unit"
         :class="{
            'item_active': isActive,
            'item_view_unit__group': subShipments.length,
            'item_view_unit-empty': !unitId,
         }"
         :data-group-id="groupId" :data-shipment-id="packageId"
         @click.stop="setUnitActive"
         @mouseover="showMenu = true" @mouseleave="showMenu = false"
    >
        <ShipmentList_item_group_icons :packageId="packageId" :indicators="indicators"/>

        <div class="list__title-line">
            <h4 class="list__title">
                <span class="list__title-icon" :class="shipmentStatus.class">
                    <SvgIcon :name="shipmentStatus.icon" class="icon"/>
                </span>
                <span class="list__title-info" :title="shipmentName">
                    {{shipmentName}}
                </span>
            </h4>
            <UnitsList_unit_timeago :unit-id="unitId" v-if="shipmentPackage?.status !== 'completed'"/><!-- ! -->
            <ShipmentList_completed_date :packageId="packageId" v-if="shipmentPackage?.status === 'completed'"/>
        </div>
        <div class="list__address-line">
            <UnitsList_unit_address :unit-id="unitId" v-if="unitId"/><!-- ! -->
            <ShipmentList_address :shipmentId="subShipments[0]?.id" v-else/>
        </div>
        <div class="item_view_unit__dropdown" v-if="subShipments.length">
            <button class="button button_command" @click="showSubUnits = !showSubUnits">
                <SvgIcon :name="showSubUnitsButtonIcon" class="icon"/>
            </button>
        </div>
        <ShipmentList_menu
            :packageId="packageId"
            :commands="['copy_shipment_id', 'edit_group']"
            v-if="(showMenu || modalsWindows?.popupOutput )"
        />
    </div>
    <div class="item_view_unit__group--active" v-show="showSubUnits" v-if="subShipments?.length">
        <template v-for="shipment in subShipments" :key="shipment.id">
            <component :is="'ShipmentList_item'"  :itemId="shipment.id"/>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {computed} from "vue";
    import unitMixin from "@/mixins/unitMixin";

    import UnitsList_unit_timeago from "@/components/units/UnitsList_unit_timeago.vue";
    import UnitsList_unit_address from "@/components/units/UnitsList_unit_address.vue";
    import ShipmentList_completed_date from "@/components/shipment/ShipmentList_completed_date";
    import ShipmentList_address from "@/components/shipment/ShipmentList_address.vue";
    //import ShipmentList_menu from "@/components/units/ShipmentList_menu.vue";
    import ShipmentList_menu from "@/components/shipment/ShipmentList_menu.vue";
    import ShipmentList_item_group_icons from "@/components/shipment/ShipmentList_item_group_icons.vue";
    import ShipmentList_item from "@/components/shipment/ShipmentList_item_default.vue"

    const shipmentStatus = {
        'started':{
            class: 'list__status--started',
            icon: 'from'
        },
        'accepted':{
            class: 'list__status--completed--planed',
            icon: 'common__checkbox'
        },
        'completed':{
            class: 'list__status--completed',
            icon: 'common__checkbox'
        },
        'cancelled':{
            class: 'list__status--completed',
            icon: 'common__checkbox'
        },
        'planed':{
            class: 'list__status--planed',
            icon: 'clock'
        },
        'staging':{
            class: 'list__status--planed',
            icon: 'clock'
        },
        'active':{
            class: 'list__status--planed',
            icon: 'clock'
        },
    }

    export default {
        name: 'ShipmentList_item_group',
        mixins: [unitMixin],
        inheritAttrs: false,
        components: {
            ShipmentList_item_group_icons,
            ShipmentList_item,
            UnitsList_unit_address,
            UnitsList_unit_timeago,
            ShipmentList_completed_date,
            ShipmentList_address,
            ShipmentList_menu,
        },
        props: {
            itemId: Number,
            groupId: Number,
        },
        data() {
            return {
                modalsWindows: {},
                showMenu: false,
                showSubUnits: false,
            }
        },
        provide() {
            return {
                modalsWindows: computed(() => this.modalsWindows)
            }
        },
        computed: {
            ...mapGetters([
                "getTimeToday",
                "getShipmentsPackagesById",
                "getShipmentsByPackageId",
                "getUserStorageKey",
                "getShipments",
            ]),
            packageId() {
                return this.itemId
            },
            shipmentPackage() {
                return this.getShipmentsPackagesById[this.itemId]
            },
            shipmentName(){
                return this.shipmentPackage?.name || ''
            },
            unitId() {
                return null//this.shipmentPackage?.unit_id
            },
            indicators() {
                return []
            },
            isActive(){
                return this.routeFilter.packageId == this.packageId || this.subShipments?.find(s => s.id == this.routeFilter.shipmentId)
            },
            showSubUnitsButtonIcon() {
                return `vector-` + (this.showSubUnits ? 'top' : 'down')
            },
            shipmentStatus() {
                return shipmentStatus[this.shipmentPackage?.status || 'planed']
            },
            subShipments() {
                return this.getShipmentsByPackageId[this.packageId] || []
            }
        },
        watch: {
            isActive(newVl) {
                if (!newVl) {
                    this.showSubUnits = false
                }
            },
        },
        methods: {
            setUnitActive(){
                if(!this.isActive) this.showSubUnits = true;
                let shipment = this.subShipments.find(id => id == this.routeFilter.shipmentId) || this.subShipments[0]
                if(!shipment?.id) return false;
                this.setRoute.shipmentId(this.$route, this.$router, shipment.id)
            },
        },
        updated() {
            // console.log(`unit ${this.unitId} updated`);
        },
        mounted() {
        },
        beforeUnmount() {
        },
    }
</script>
<style lang="scss" scoped>
@import "~@/scss/02-components/shipment-list-item";
</style>
